import type { RouteConfigItem } from '@/entities/workspace-config';
import { ROUTE_PATTERNS } from './route-patterns';

/**
 * workspaceConfig 로드 전 사용할 fallback
 *
 * ROUTE_PATTERNS에서 componentKey·requiredRole을 직접 파생하므로
 * 인덱스 동기화가 필요 없습니다.
 */
export const FALLBACK_ROUTE_CONFIGS: RouteConfigItem[] = ROUTE_PATTERNS.map((pattern) => ({
  path: pattern.path as readonly string[],
  title: pattern.title,
  componentKey: pattern.componentKey,
  requiredRole: pattern.requiredRole,
  allowPlannerSelf: pattern.path[0] === 'planners' && pattern.path[1]?.startsWith(':'),
}));
